export default () => ({
  trigger: {
    name: 'shopping_cart_dropdown.show_energy_label',
    params: {},
  },
  config: {
    event: {
      name: 'show_content',
      params: {
        sub_feature: 'energy_label',
      },
    },
    nonInt: true,
  },
});
